// extracted by mini-css-extract-plugin
export default {"displayName":"Form_displayName__982Ip","optionRow":"Form_optionRow__g7r-L","selectedOption":"Form_selectedOption__5gUrE","deleteBtn":"Form_deleteBtn__wT2LF"};